function heroVideo() {
    // Stops modal video from playing when modal is closed
	$("body").on('hidden.bs.modal', function (e) {
		var $iframes = $(e.target).find("iframe#hpmodal");
		$iframes.each(function(index, iframe){
			$(iframe).attr("src", $(iframe).attr("src"));
		});
	});


	
	
	// get vimeo hero background video
	const vimeoWrapper = document.querySelector('.vimeo-wrapper');

	
	// only run if vimeo-wrapper is on the page
	if (typeof(vimeoWrapper) != 'undefined' && vimeoWrapper != null) {
		// checks to see if parameter is inside the viewport
		function isInView(el) {
			const box = el.getBoundingClientRect();
			return box.top < window.innerHeight && box.bottom >= 0;
		}

		const iframe = document.querySelector('iframe');
    	const player = new Vimeo.Player(iframe);
		// onscroll play if vimeoWrapper is in viewport and pause if not
		window.onscroll = function() {
			if (isInView(vimeoWrapper)) {
				player.play();
			} else {
				player.pause();
			}
			
		};
	}
}

export { heroVideo as default };